export default __webpack_public_path__ + "static/A04-73b1bd2351e5aca6e2daf827632ad28f.jpg";